import serviceTicketPartsComponent from './service_ticket_parts.component';
import serviceTicketPartsCreate from './create'
import serviceTicketPartsEdit from './edit'
import serviceTicketPartsAll from './all'

let serviceTicketPartsModule = angular.module('serviceTicketParts', [
    serviceTicketPartsCreate,
    serviceTicketPartsEdit,
    serviceTicketPartsAll
])

    .component('serviceTicketParts', serviceTicketPartsComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $stateProvider
            .state('service-ticket-parts.edit', {
                url: '/edit/:id',
                component: 'serviceTicketPartsEdit'
            })

            .state('service-ticket-parts.create', {
                url: '/create',
                component: 'serviceTicketPartsCreate'
            })

            .state('service-ticket-parts.all', {
                url: '/all/:page',
                component: 'serviceTicketPartsAll'
            })
    })
    .name;

export default serviceTicketPartsModule;



// WEBPACK FOOTER //
// ./client/app/components/service_ticket_parts/index.js